import { Ref, forwardRef } from 'react';
import styled from 'styled-components';
import { MultipleUsers16 } from 'ui/icons/aurora/16px/MultipleUsers16';
import { Button, BUTTON_VARIANTS } from 'ui/button';
import { body2, colors, spacing } from 'ui/theme';
import { ButtonNoVariantProps } from 'ui/button/types';

export const ForwardedSecondaryButton = forwardRef<HTMLButtonElement, ButtonNoVariantProps>(
  (props, forwardedRef: Ref<HTMLButtonElement>) => {
    return (
      <Button {...props} ref={forwardedRef} variant={BUTTON_VARIANTS.SECONDARY}>
        {props.children}
      </Button>
    );
  },
);
export const PreviewButton = styled(ForwardedSecondaryButton)`
  &:hover path {
    fill: ${colors.iconInteractive};
  }
`;

export const StyledMultipleUsers = styled(MultipleUsers16)`
  path {
    stroke: none !important;
  }
`;

export const UserPreviewContentContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Body2Bold = styled.span`
  ${body2}
  font-weight: bold;
`;

export const ApproxUserCount = styled(Body2Bold)<{ $color: string }>`
  color: ${(props) => props.$color};
`;

export const UserPreviewTextContainer = styled.p`
  ${body2};
  margin-left: ${spacing.threeQuarter};
`;

export const MutatePreviewUserContentContainer = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
`;

export const MutatePreviewUsersTextContent = styled.div`
  margin-left: ${spacing.threeQuarter};
`;

export const PreviewUsersExtendedLoadingContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`;

export const PreviewUsersExtendedLoadingSubContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${spacing.quarter};
`;
